import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/PortfolioWebsite/PortfolioWebsite/app/best/[slug]/MarkdownSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/PortfolioWebsite/PortfolioWebsite/components/blog/BlogFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReadingFatiguePopup"] */ "/home/runner/work/PortfolioWebsite/PortfolioWebsite/components/portfolio/ReadingFatiguePopup.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/PortfolioWebsite/PortfolioWebsite/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/PortfolioWebsite/PortfolioWebsite/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/PortfolioWebsite/PortfolioWebsite/node_modules/next/dist/client/script.js");
